var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KeychainKeyTypesLC } from '@interfaces/keychain.interface';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { refreshActiveAccount } from '@popup/steem/actions/active-account.actions';
import BlockchainTransactionUtils from '@popup/steem/utils/blockchain.utils';
import { BaseCurrencies } from '@popup/steem/utils/currency.utils';
import WitnessUtils from '@popup/steem/utils/witness.utils';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
const EditMyWitness = ({ witnessInfo, setEditMode, activeAccount, addToLoadingList, removeFromLoadingList, setErrorMessage, setSuccessMessage, refreshActiveAccount, }) => {
    const [formParams, setFormParams] = useState({
        accountCreationFee: witnessInfo.params.accountCreationFee,
        maximumBlockSize: witnessInfo.params.maximumBlockSize,
        sbdInterestRate: witnessInfo.params.sbdInterestRate,
        signingKey: witnessInfo.signingKey,
        url: witnessInfo.url,
    });
    const handleUpdateWitnessProps = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!formParams.signingKey.startsWith('STM')) {
            setErrorMessage('popup_html_public_key_needed');
            return;
        }
        try {
            addToLoadingList('html_popup_update_witness_operation');
            const success = yield WitnessUtils.updateWitnessParameters(activeAccount.name, formParams, activeAccount.keys.active);
            addToLoadingList('html_popup_confirm_transaction_operation');
            removeFromLoadingList('html_popup_update_witness_operation');
            yield BlockchainTransactionUtils.delayRefresh();
            removeFromLoadingList('html_popup_confirm_transaction_operation');
            refreshActiveAccount();
            if (success) {
                goBackPage();
                if (success.isUsingMultisig) {
                    setSuccessMessage('multisig_transaction_sent_to_signers');
                }
                else
                    setSuccessMessage('popup_success_witness_account_update');
            }
            else {
                setErrorMessage('popup_error_witness_account_update', [
                    `${activeAccount.name}`,
                ]);
            }
        }
        catch (err) {
            setErrorMessage(err.message);
            removeFromLoadingList('html_popup_update_witness_operation');
            removeFromLoadingList('html_popup_confirm_transaction_operation');
        }
        finally {
            removeFromLoadingList('html_popup_confirm_transaction_operation');
            removeFromLoadingList('html_popup_confirm_transaction_operation');
        }
    });
    const handleFormParams = (name, value) => {
        setFormParams((prevFormParams) => {
            return Object.assign(Object.assign({}, prevFormParams), { [name]: value });
        });
    };
    const goBackPage = () => {
        setEditMode(false);
    };
    return (React.createElement("div", { className: "edit-my-witness-component" },
        React.createElement("div", { className: "field" },
            React.createElement(InputComponent, { label: "popup_html_currency", type: InputType.TEXT, value: BaseCurrencies.STEEM.toUpperCase(), onChange: () => null, disabled: true }),
            React.createElement(InputComponent, { label: "popup_html_witness_information_account_creation_fee_label", type: InputType.TEXT, placeholder: "popup_html_witness_information_account_creation_fee_placeholder_text", value: formParams.accountCreationFee, onChange: (value) => handleFormParams('accountCreationFee', value) })),
        React.createElement(InputComponent, { label: "popup_html_witness_information_maximum_block_size_label", type: InputType.TEXT, placeholder: "popup_html_witness_information_block_size_placeholder_text", value: formParams.maximumBlockSize, onChange: (value) => handleFormParams('maximumBlockSize', value) }),
        React.createElement(InputComponent, { label: "popup_html_witness_information_hbd_interest_rate_label", type: InputType.TEXT, placeholder: "popup_html_witness_information_hbd_interest_rate_placeholder_text", value: formParams.sbdInterestRate, onChange: (value) => handleFormParams('sbdInterestRate', value) }),
        React.createElement(InputComponent, { type: InputType.TEXT, label: "popup_html_witness_information_signing_key_label", placeholder: "popup_html_witness_information_signing_key_label", value: formParams.signingKey, onChange: (value) => handleFormParams('signingKey', value) }),
        React.createElement(InputComponent, { type: InputType.TEXT, label: "popup_html_witness_information_url_label", placeholder: "popup_html_witness_information_url_label", value: formParams.url, onChange: (value) => handleFormParams('url', value) }),
        React.createElement("div", { className: "bottom-panel" },
            React.createElement(ButtonComponent, { label: 'popup_html_button_label_cancel', onClick: () => goBackPage(), type: ButtonType.ALTERNATIVE }),
            React.createElement(OperationButtonComponent, { requiredKey: KeychainKeyTypesLC.active, onClick: () => handleUpdateWitnessProps(), label: 'popup_html_operation_button_save' }))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    addToLoadingList,
    removeFromLoadingList,
    setErrorMessage,
    setSuccessMessage,
    refreshActiveAccount,
});
export const EditMyWitnessComponent = connector(EditMyWitness);
